import { Api } from '@/api/api';

export class AccountApi extends Api {
    public async loginAsync(email: string, password: string): Promise<void> {
        return await this.postAsync<void>(`v2/account/login`, { email: email, password: password });
    }
    public async logoutAsync(): Promise<void> {
        return await this.postAsync<void>(`v2/account/logout`, {});
    }
    public async changePasswordAsync(request: { newPassword: string, currentPassword: string }): Promise<void> {
        return await this.postAsync<void>(`v2/account/change-password`, request);
    }
    public async forgotPasswordAsync(email: string): Promise<void> {
        return await this.postAsync<void>(`v2/account/forgot-password`, { email: email });
    }
}
